import { translate } from '@thoughtspot/i18n';
import { getTranslatedInfoForMessageCode } from "../../../utils/error-handling/error-strings-mapping";
import { getErrorObjectFromGraphQLErrors } from "../../../utils/error-handling/error-utils";
import { getErrorCode } from '../../user-management/util';
const DUPLICATE_NAME_CODES = new Set([
    '10452',
    '10458',
    '13098',
    '13099',
    '13100',
    '13108',
]);
const DUPLICATE_NAME_MESSAGE_PATTERNS = [
    /(name|identifier).*already exists/i,
    /same name exists/i,
    /(name|identifier).*already in use/i,
    /duplicate (name|key|entry|identifier)/i,
];
const collectErrorMessages = (rawErrorObj, err) => {
    const messages = [];
    (rawErrorObj ?? []).forEach(e => {
        if (e?.message)
            messages.push(e.message);
        const upstream = e?.errorObj?.extensions?.exception
            ?.upstreamResponse?.data;
        if (typeof upstream?.message === 'string') {
            messages.push(upstream.message);
        }
        const debugEntries = Array.isArray(upstream?.debug)
            ? upstream.debug
            : [upstream?.debug];
        debugEntries.forEach((entry) => {
            if (typeof entry === 'string')
                messages.push(entry);
        });
    });
    const apolloMessage = err?.message;
    if (typeof apolloMessage === 'string')
        messages.push(apolloMessage);
    return messages;
};
const matchesDuplicatePattern = (messages) => messages.some(m => DUPLICATE_NAME_MESSAGE_PATTERNS.some(p => p.test(m)));
export const classifyServerError = (err, fallbackTranslationKey) => {
    const rawErrorObj = getErrorObjectFromGraphQLErrors(err);
    const code = String(getErrorCode(rawErrorObj) ?? '');
    const isDuplicateName = DUPLICATE_NAME_CODES.has(code) ||
        matchesDuplicatePattern(collectErrorMessages(rawErrorObj, err));
    const summaryKey = getTranslatedInfoForMessageCode(code, fallbackTranslationKey).summary;
    const message = summaryKey ? translate(summaryKey) : '';
    return { code, isDuplicateName, message, rawErrorObj };
};
//# sourceMappingURL=server-errors.js.map